import { cn } from '@/shared/ui/cn';

export type CountBadgeProps = {
  value: number;
  /** Au-delà, on écrit « 9+ » ou « 99+ » : le chiffre exact n'apporte rien. */
  max?: number;
  className?: string;
};

/**
 * Pastille rouge des non-lus. C'est le seul rouge « d'alerte » de l'interface :
 * notifications, messages et panier, jamais un statut.
 */
export function CountBadge({ value, max = 99, className }: CountBadgeProps) {
  if (value <= 0) {
    return null;
  }
  return (
    <span
      className={cn(
        'pointer-events-none inline-grid h-[17px] min-w-[17px] place-items-center rounded-pill',
        'border-2 border-surface bg-danger px-[3px] text-[10px] leading-3 font-medium text-fg-on-primary tabular',
        className,
      )}
    >
      {value > max ? `${max}+` : value}
    </span>
  );
}
